import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../common/types';
import { SMLPreview } from '../smlPreview/SMLPreview';
import { SMLPreviewStage } from '../smartLinkDetailsView/SMLPreviewStage';
import { SMLDeviceToggle } from '../smartLinkDetailsView/toolbar/SMLDeviceToggle';
import { PreviewDevice } from '../smartLinkDetailsView/toolbar/previewDevice';
import { SMLPreviewMessageData } from '../smartLinkDetailsView/messageListeners/types';
import { editorMessages } from './editorMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './SMLEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SMLEditorStageProps {
  /** The draft as the preview draws it (a row whose delete waits is left out). */
  smartLink: SerializedSmartLink;
  selectedWidgetUUID: string | null;
  hoveredWidgetUUID: string | null;
  onPreviewMessage: (data: SMLPreviewMessageData) => void;
}

/** The preview beside the panel (design a1): Phone or Desktop, and the live draft of the page. */
const SMLEditorStageComponent: React.FC<SMLEditorStageProps> = ({
  smartLink,
  selectedWidgetUUID,
  hoveredWidgetUUID,
  onPreviewMessage,
}) => {
  const intl = useIntl();
  const [device, setDevice] = useState<PreviewDevice>('mobile');
  const onDevice = useCallback((next: PreviewDevice) => setDevice(next), []);
  const blockCount = smartLink.recentSmartLinkVersion.widgets?.length ?? 0;

  return (
    <div className={styles.stage}>
      <div className={styles.stageBar}>
        <SMLDeviceToggle device={device} onChange={onDevice} />
        <span className={styles.stageHint}>
          {intl.formatMessage(blockCount === 0 ? editorMessages.publishNoBlocks : editorMessages.stageHint)}
        </span>
      </div>
      <SMLPreviewStage device={device}>
        <SMLPreview
          smartLink={smartLink}
          type="column"
          onPreviewMessageEvent={onPreviewMessage}
          showOpenPreviewBar={false}
          selectedWidgetUUID={selectedWidgetUUID}
          hoveredWidgetUUID={hoveredWidgetUUID}
        />
      </SMLPreviewStage>
    </div>
  );
};

export const SMLEditorStage = TypedMemo(SMLEditorStageComponent);
